<template>
  <help-info-wrapper
    :info.sync="helpData"
    :service-name="serviceName"
    class="warp"
  >
    <template>
      <v-card flat>
        <v-expansion-panels
          :class="singleGallery ? '' : 'pa-2'"
          :flat="singleGallery"
          :mandatory="singleGallery"
          focusable
        >
          <v-expansion-panel
            v-for="(salon, index) in gallery"
            :key="index"
            class="mt-2 rounded-lg"
          >
            <v-expansion-panel-header v-if="!singleGallery">
              <div v-if="index !== editGalleryName">{{ salon.name }}</div>
              <div class="rowinfo" v-if="index === editGalleryName">
                <div class="contnetinfo">
                  <v-text-field
                    v-if="index === editGalleryName"
                    v-model="salon.name"
                    append-icon="check"
                    class="my-2"
                    dense
                    hide-details
                    label="نام گالری"
                    outlined
                    @click.stop
                    @click:append.stop="editGalleryName = -1"
                  />
                </div>
                <help-info
                  :element-name="`${serviceName}-${componentName}-data-editGalleryName`"
                  :service-name="serviceName"
                  :help-data="helpData"
                  class="buttoninfo"
                  label="نام گالری"
                />
              </div>

              <v-spacer />

              <div class="rowinfo justify-end" v-if="index !== editGalleryName">
                <v-btn
                  v-if="index !== editGalleryName"
                  icon
                  max-width="36"
                  @click.stop="editGalleryName = index"
                >
                  <v-icon small>mdi-pencil</v-icon>
                </v-btn>
                <help-info
                  v-show="index === -1"
                  :element-name="`${serviceName}-${componentName}-editGalleryName`"
                  :service-name="serviceName"
                  :help-data="helpData"
                  class="buttoninfo"
                  label="گالری انتخابی"
                />
              </div>

              <v-btn
                v-if="gallery.length > 1"
                icon
                max-width="36"
                @click="gallery.splice(index, 1)"
              >
                <v-icon>mdi-delete</v-icon>
              </v-btn>
            </v-expansion-panel-header>

            <v-expansion-panel-content class="mt-4">
              <div class="rowinfo">
                <div class="d-flex align-start contentinfo">
                  <v-btn
                    block
                    color="success"
                    outlined
                    @click="
                      () => {
                        manualDialog = true;
                        selectedSalon = { ...salon };
                      }
                    "
                  >
                    انتخاب ویدئو
                    <v-icon right>mdi-video-plus-outline</v-icon>
                  </v-btn>
                </div>
                <help-info
                  :element-name="`${serviceName}-${componentName}-data-selectvideo`"
                  :service-name="serviceName"
                  :help-data="helpData"
                  class="buttoninfo"
                  label="انتخاب ویدئو"
                />
              </div>

              <v-row v-if="rerender" no-gutters>
                <v-col
                  v-for="(video, index) in salon.images"
                  :key="index"
                  class="align-center pa-2 position-relative"
                  cols="12"
                >
                  <div class="rowinfo">
                    <div class="contentinfo">
                      <div class="border rounded" @click="selectVideo(video)">
                        <template v-if="video.url || video.file_link">
                          <v-btn
                            class="float-end zindex-5 p-0 ms-auto my-auto"
                            icon
                            small
                            @click.stop="
                              deleteSelectedImage(salon, video, index)
                            "
                          >
                            <v-icon style="color: #999 !important"
                              >mdi-delete</v-icon
                            >
                          </v-btn>

                          <v-card
                            class="pa-2 text-center justify-space-between d-flex align-center"
                            flat
                          >
                            <v-btn
                              :disabled="index === 0"
                              icon
                              @click.stop="moveUp(salon, video)"
                            >
                              <v-icon>mdi-chevron-up</v-icon>
                            </v-btn>

                            <!-- <iframe :src="video.url || video.file_link"/> -->
                            <video-iframe :key-id="index" :video="video" />

                            <v-btn
                              :disabled="index >= salon.images.length - 1"
                              icon
                              @click.stop="moveDown(salon, video)"
                            >
                              <v-icon>mdi-chevron-down</v-icon>
                            </v-btn>
                          </v-card>
                        </template>

                        <template v-else>
                          <v-text-field
                            v-model="setUrl"
                            class="ma-2"
                            dense
                            hide-details
                            label="آدرس ویدیو"
                            outlined
                            @click.stop
                            @keydown.enter="
                              () =>
                                checkVideoUrl ? addToGallery(video) : false
                            "
                          >
                            <template v-slot:append-outer>
                              <v-btn
                                :disabled="!checkVideoUrl"
                                color="success"
                                icon
                                small
                                @click.stop="addToGallery(video)"
                              >
                                <v-icon>mdi-plus</v-icon>
                              </v-btn>

                              <v-btn
                                icon
                                small
                                @click.stop="
                                  deleteSelectedImage(salon, video, index)
                                "
                              >
                                <v-icon style="color: #999 !important"
                                  >mdi-delete</v-icon
                                >
                              </v-btn>
                            </template>
                          </v-text-field>
                        </template>
                      </div>
                    </div>
                    <help-info
                      v-show="index === -1"
                      :element-name="`${serviceName}-${componentName}-data-selectedvideo`"
                      :service-name="serviceName"
                      :help-data="helpData"
                      class="buttoninfo"
                      label="ویدئو انتخابی"
                    />
                  </div>
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>

        <custom-popup
          id="gallery"
          v-model="manualDialog"
          :cons="{ title: 'افزودن ویدیو' }"
          max-width="960"
          reloadable
        >
          <video-uploader
            v-model="selectedSalon"
            :single-gallery="singleGallery"
            @close="manualDialog = false"
          />
        </custom-popup>

        <custom-popup
          id="edit-gallery"
          v-model="editDialog"
          :cons="{ title: 'ویرایش ویدیو' }"
          max-width="500"
        >
          <v-card class="p-8">
            <div class="rowinfo">
              <v-text-field
                v-model="selectedVideo.title"
                class="my-2 contnetinfo"
                dense
                hide-details
                label="عنوان"
                outlined
              />
              <help-info
                :element-name="`${serviceName}-${componentName}-data-title`"
                :service-name="serviceName"
                :help-data="helpData"
                class="buttoninfo"
                label="عنوان"
              />
            </div>
            <div class="rowinfo">
              <v-text-field
                v-model="selectedVideo.link"
                :rules="[addVideoRule.link]"
                class="my-2 contnetinfo"
                dense
                hide-details
                label="لینک انتقال"
                outlined
              />
              <help-info
                :element-name="`${serviceName}-${componentName}-selectedVideo-link`"
                :service-name="serviceName"
                :help-data="helpData"
                class="buttoninfo"
                label="لینک انتقال"
              />
            </div>
            <div class="rowinfo">
              <v-textarea
                v-model="selectedVideo.description"
                class="my-2 contnetinfo"
                dense
                hide-details
                label="توضیحات"
                maxLength="250"
                outlined
                rows="5"
              />

              <help-info
                :element-name="`${serviceName}-${componentName}-selectedVideo-description`"
                :service-name="serviceName"
                :help-data="helpData"
                class="buttoninfo"
                label="توضیحات"
              />
            </div>
          </v-card>
        </custom-popup>

        <v-card-actions v-if="!singleGallery" class="px-2 pt-6">
          <div class="rowinfo" style="width: 100% !important">
            <v-btn
              color="success"
              class="contnetinfo"
              style="max-width: 100% !important; flex: 1 1 auto !important"
              outlined
              @click="addGallery"
            >
              افزودن گالری
              <v-icon right>mdi-movie-open-plus-outline</v-icon>
            </v-btn>
            <help-info
              :element-name="`${serviceName}-${componentName}-singleGallery`"
              :service-name="serviceName"
              :help-data="helpData"
              class="buttoninfo"
              label="افزودن گالری"
            />
          </div>
        </v-card-actions>
      </v-card>
    </template>
  </help-info-wrapper>
</template>

<script>
import VideoUploader from "./videoUploader/videoUploader";
import VideoIframe from "./videoUploader/videoIframe";

export default {
  name: "VideoGallery",

  components: { VideoIframe, VideoUploader },

  props: {
    data: {
      type: Object,
      require: true,
    },
    singleGallery: {
      type: Boolean,
      default() {
        return this.provideSingleGallery;
      },
    },
  },

  inject: {
    provideSingleGallery: { default: false },
  },

  data() {
    return {
      helpData: [],
      serviceName: "Payamakland",
      componentName: "videoGallery",
      addVideoRule: {
        link: (value) =>
          this.isDomain(value) ||
          "دامنه سایت باید بصورت https://terminalads.com یا terminalads.com وارد شود. ",
      },
      manualDialog: false,
      editDialog: false,
      manualVideo: {
        title: "",
        url: "",
        description: "",
        link: "",
      },
      gallery: [{ name: "گالری", images: [] }],
      setUrl: "",
      selectedVideo: {},
      selectedSalon: {},
      editGalleryName: -1,
      rerender: true,
    };
  },

  mounted() {
    if (this.data.video_gallery) this.gallery = this.data.video_gallery;
  },

  computed: {
    checkVideoUrl() {
      let reg = new RegExp(/<iframe.*src="(.*?)".*>/, "gms");

      return reg.exec(this.setUrl)?.[1];
    },
  },

  watch: {
    "data.video_gallery": {
      deep: true,
      handler(newVal) {
        if (newVal && Array.isArray(newVal) && newVal.length > 0) {
          this.gallery = newVal;
        } else {
          this.gallery = [{ name: "گالری", images: [] }];
        }
      },
    },
    gallery: {
      deep: true,
      handler(value) {
        this.data["video_gallery"] = value;
        this.$nextTick(() => {
          this.$root.$emit("fetchDragList");
        });
      },
    },
  },

  methods: {
    moveUp(salon, image) {
      let imageIndex = salon.images.indexOf(image);
      let previousIndex = imageIndex - 1;
      let tempPreviousImage = { ...salon.images[previousIndex] };
      let tempCurrentImage = { ...image };

      salon.images[imageIndex] = tempPreviousImage;
      salon.images[previousIndex] = tempCurrentImage;

      this.$forceUpdate();

      this.data["video_gallery"] = null;
      this.$nextTick(() => {
        this.data["video_gallery"] = this.gallery;
      });
    },
    moveDown(salon, image) {
      let imageIndex = salon.images.indexOf(image);
      let nextIndex = imageIndex + 1;
      let tempPreviousImage = { ...salon.images[nextIndex] };
      let tempCurrentImage = { ...image };

      salon.images[imageIndex] = tempPreviousImage;
      salon.images[nextIndex] = tempCurrentImage;

      this.$forceUpdate();

      this.data["video_gallery"] = null;
      this.$nextTick(() => {
        this.data["video_gallery"] = this.gallery;
      });
    },
    addGallery() {
      this.gallery.push({
        name: "گالری " + this.gallery.length,
        images: [],
      });
    },
    addToGallery(video) {
      video.url = this.checkVideoUrl;
      this.$nextTick(() => {
        this.setUrl = "";
        this.manualVideo = {
          title: "",
          url: "",
          description: "",
          link: "",
        };
      });
    },
    deleteSelectedImage(salon, image, index) {
      // salon.images.splice(salon.images.indexOf(image), 1);
      salon.images.splice(index, 1);
      this.rerender = false;
      this.$nextTick(() => {
        this.rerender = true;
      });
    },
    selectVideo(image) {
      this.selectedVideo = image;
      this.editDialog = true;
    },
    isDomain(str) {
      var regex = new RegExp(
        "^(http[s]?:\\/\\/(www\\.)?|ftp:\\/\\/(www\\.)?|www\\.){1}([0-9A-Za-z-\\.@:%_\+~#=]+)+((\\.[a-zA-Z]{2,3})+)(/(.)*)?(\\?(.)*)?"
      );
      var without_regex = new RegExp(
        "^([0-9A-Za-z-\\.@:%_\+~#=]+)+((\\.[a-zA-Z]{2,3})+)(/(.)*)?(\\?(.)*)?"
      );

      return (
        !str || regex.test(str) || without_regex.test(str) || str.length <= 0
      );
    },
  },
};
</script>

<style scoped></style>
